/**
 * Outlet vocabulary in the admin's words. Keys are what models/Outlet.js in
 * web-backend stores.
 */

export const OUTLET_KINDS = [
  { value: "restaurant", label: "Restaurant", icon: "restaurant" },
  { value: "cafe", label: "Café", icon: "local_cafe" },
  { value: "bar", label: "Bar", icon: "local_bar" },
  { value: "lounge", label: "Lounge", icon: "weekend" },
  { value: "poolside", label: "Poolside", icon: "pool" },
];

export const KIND = OUTLET_KINDS.reduce((acc, k) => ({ ...acc, [k.value]: k }), {});

export const DAYS = [
  { value: "monday", label: "Monday", short: "Mon" },
  { value: "tuesday", label: "Tuesday", short: "Tue" },
  { value: "wednesday", label: "Wednesday", short: "Wed" },
  { value: "thursday", label: "Thursday", short: "Thu" },
  { value: "friday", label: "Friday", short: "Fri" },
  { value: "saturday", label: "Saturday", short: "Sat" },
  { value: "sunday", label: "Sunday", short: "Sun" },
];

export const OCCASIONS = {
  birthday: "Birthday",
  anniversary: "Anniversary",
  business: "Business",
  other: "Other occasion",
};

/** The server's reservation defaults (utils/tableSlots.js DEFAULTS). */
export const RESERVATION_DEFAULTS = {
  slotMinutes: 30,
  sittingMinutes: 90,
  maxPartySize: 12,
  leadMinutes: 60,
  maxDaysAhead: 30,
};

const toMin = (hhmm) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm || "");
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
};

/** A close at or before the open runs past midnight — same rule as the server. */
export const pastMidnight = (from, to) => {
  const a = toMin(from);
  const b = toMin(to);
  return a != null && b != null && b <= a;
};

/** "Mon–Sun · 19:00–23:00" for a reservation window. */
export const windowSummary = (w) => {
  const days = w.days && w.days.length && w.days.length < 7
    ? DAYS.filter((d) => w.days.includes(d.value)).map((d) => d.short).join(", ")
    : "Every day";
  return `${days} · ${w.from}–${w.to}${pastMidnight(w.from, w.to) ? " (next day)" : ""}`;
};
